import React from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import logo from '~/assets/images/HAC-logo.png';
import facebookIcon from '~/assets/images/facebook-icon.png';
import linkedinIcon from '~/assets/images/linkedin-icon.png';

const SOCIAL_LINKS = [
  { icon: facebookIcon, alt: 'Facebook', href: 'https://www.facebook.com/HongAnhComputer.Official' },
  { icon: linkedinIcon, alt: 'LinkedIn', href: 'https://www.linkedin.com/company/honganhcomputer' },
];

const TheFooter = () => {
  const { t } = useTranslation();

  const companyLinks = [
    { title: t('footer.companyLinks.products'), href: 'https://honganh.vn/danh-muc-san-pham/' },
    { title: t('footer.companyLinks.news'), href: 'https://honganh.vn/tin-tuc/' },
    { title: t('footer.companyLinks.contact'), href: 'https://honganh.vn/lien-he/' },
    { title: t('footer.companyLinks.recruitment'), href: 'https://honganh.vn/careers/' },
  ];

  const productLinks = [
    { title: t('footer.warrantyPolicy'), href: 'https://honganh.vn/chinh-sach-bao-hanh/' },
    { title: t('footer.returnPolicy'), href: 'https://honganh.vn/quy-dinh-doi-tra-hang/' },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.columns}>
        <div className={styles.about}>
          <div className={styles.brand}>
            <img className={styles.icon} src={logo} alt="logo" />
            <div className={styles.brandName}>
              <div>{t('footer.companyName')}</div>
              <div className={styles.brandNameSuffix}>{t('footer.companyNameSuffix')}</div>
            </div>
          </div>
          <div className={styles.subtitle}>{t('footer.logoSubtitle')}</div>
          <div className={styles.taxCode}>{t('footer.taxCode')}</div>
          <div className={styles.socials}>
            {SOCIAL_LINKS.map(({ icon, alt, href }) => (
              <a href={href} target="_blank" rel="noreferrer" key={alt}>
                <img src={icon} alt={alt} className={styles.socialIcon} />
              </a>
            ))}
          </div>
        </div>

        <div className={styles.column}>
          <div className={styles.columnTitle}>{t('footer.companyColumnTitle')}</div>
          {companyLinks.map(({ title, href }) => (
            <a href={href} target="_blank" rel="noreferrer" key={title} className={styles.link}>
              {title}
            </a>
          ))}
        </div>

        <div className={styles.column}>
          <div className={styles.columnTitle}>{t('footer.productColumnTitle')}</div>
          {productLinks.map(({ title, href }) => (
            <a href={href} target="_blank" rel="noreferrer" key={title} className={styles.link}>
              {title}
            </a>
          ))}
        </div>

        <div className={styles.column}>
          <div className={styles.columnTitle}>{t('footer.contactColumnTitle')}</div>
          <div className={styles.contactBlock}>
            <div className={styles.contactLabel}>{t('footer.hotlineLabel')}</div>
            <a href="tel:+84945416666" className={`${styles.contactValue} ${styles.hotline}`}>
              {t('footer.hotline')}
            </a>
            <div className={styles.contactHint}>{t('footer.workingHours')}</div>
          </div>
          <div className={styles.contactBlock}>
            <div className={styles.contactLabel}>{t('footer.supportEmailLabel')}</div>
            <a href="mailto:cskh@honganh.vn" className={styles.contactValue}>
              {t('footer.supportEmail')}
            </a>
          </div>
          <div className={styles.contactBlock}>
            <div className={styles.contactLabel}>{t('footer.addressLabel')}</div>
            <a
              href="https://maps.app.goo.gl/yPc1Pg7aKJ69T23n6"
              target="_blank"
              rel="noreferrer"
              className={styles.contactValue}
            >
              {t('footer.address')}
            </a>
          </div>
        </div>
      </div>

      <div className={styles.divider} />
      <div className={styles.copyright}>{t('footer.copyright')}</div>
    </div>
  );
};

export default TheFooter;
